import axios from "axios";
let instance = axios.create( {
    baseURL: process.env.REACT_APP_API_SERVER_URL,
    timeout: 100000,
    headers: {
        "Content-Type": "Application/json",
    }
})

export function getStoreInfo(store_identifier) {
    // console.log(process.env.REACT_APP_MANAGE_SERVER_URL);
    return instance.get(`${process.env.REACT_APP_API_SERVER_URL}/front/store?store_identifier=`+store_identifier)
}

export function createOrderAuth(data) {
    return instance.post(`${process.env.REACT_APP_API_SERVER_URL}/front/orderauth`, data)
}